import React from 'react';
import { Provider } from 'react-redux';
import store from './store';
import App from './App';
import ReactDOM from 'react-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter } from 'react-router-dom';
import './assets/styles/variables.scss';
import './assets/styles/genericStyles.scss';
import './index.css';
import './index.scss';
import '@styles/variables.scss';
import '@styles/index.scss';
import './firebase/firebase';
import { persistStore } from 'redux-persist';
import { startNaviExtensionService } from './service/naviExtension.service';
import { toast } from '@navi/web-ui/lib/primitives/Toast';
import MapProvider from './pages/LiveLocationTracker/Context/mapProvider';

const persistor = persistStore(store);
try {
  startNaviExtensionService();
} catch (e) {
  toast('Extenstion Service not started', { type: 'error' });
}

async function deferRender() {
  if (process.env.NODE_ENV !== 'development') {
    return;
  }

  const { worker } = await import('./msw/setupMsw');

  // `worker.start()` returns a Promise that resolves
  // once the Service Worker is up and ready to intercept requests.
  return;
  return worker.start({ onUnhandledRequest: 'bypass' });
}

deferRender().then(() => {
  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}></PersistGate>
        <BrowserRouter basename={import.meta.env.VITE_BASE_URL || '/'}>
          <MapProvider>
            <App />
          </MapProvider>
        </BrowserRouter>
      </Provider>
    </React.StrictMode>,
    document.getElementById('root')
  );
});
